module.exports = __webpack_public_path__ + "static/media/print1.0c02a845.jpg";